// 即时销量

const state = {
  msgCounter: 0, // 收到 异步下载任务 生成完成提示的次数
}

const mutations = {
  INC_MSG_COUNTER: (state) => {
    state.msgCounter += 1
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
